import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface JobQuoteWalkWayProps {
    walkWayItem: WalkWayItem;
    canEdit: boolean;
    showModal: boolean;
    hideModal(): void;
    update(walkWayayItem: WalkWayItem): void;
    save(): void;
}

interface WalkWayItem {
    id: number;
    steepRoofPitch: number;
    quantity: number;
    extraHours: number;
    quoteNote: string;
}

const JobQuoteWalkWayModal = (props: JobQuoteWalkWayProps) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    const updateErrors = (errorName: string) => {
        var errorList = errors;
        if (errorName) {
            delete errors[errorName];
            setErrors(errorList);
        }
    }

    const handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        updateErrors(e.target.name);
        
        let walkWayItem = props.walkWayItem;
        let change: any = {};
        change = walkWayItem;
        change[e.target.name] = e.target.value;
        
        props.update(change);
    }

    const handleChangeNumber = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        updateErrors(e.target.name);

        let walkWayItem = props.walkWayItem;
        let change: any = {};
        change = walkWayItem;
        change[e.target.name] = e.target.value * 1;

        props.update(change);
    }

    const hideModal = () => {
        setErrors({});
        props.hideModal();
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;
        var items = props.walkWayItem;

        if (items.steepRoofPitch < 0) {
            formIsValid = false;
            errorList["steepRoofPitch"] = "Roof Pitch is required";
        }

        var quantity = items.quantity * 1;
        if (quantity <= 0) {
            formIsValid = false;
            errorList["quantity"] = "Quantity is required";
        }

        setErrors(errorList);
        return formIsValid;
    }


    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            props.save();
        }
    }

    const roofPitchHeader = "Roof Pitch > 26 degrees?";

    const renderDetails = (
        <div>
            <Modal static show={props.showModal} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Walk Way Options</Modal.Title>
                    <button type="button" className="close" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <label className="input-group" htmlFor="quantity">
                        <span className="label">Quantity</span>
                        <input type='number' min="0" step="1" id="quantity" name="quantity" className='form-control textalignright' value={props.walkWayItem.quantity} onChange={(e) => handleChangeNumber(e)} disabled={!props.canEdit} />
                    </label>
                    <span className="label errors">{errors["quantity"]}</span>

                    <label className="input-group" htmlFor="steepRoofPitch">
                        <span className="label">{roofPitchHeader}</span>
                        <select className="select" id="steepRoofPitch" name="steepRoofPitch" value={props.walkWayItem.steepRoofPitch} onChange={(e) => handleChangeNumber(e)} disabled={!props.canEdit}>
                            <option defaultValue="-1"></option>
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                        </select>
                    </label>
                    <span className="label errors">{errors["kwikstageInstalledFor"]}</span>

                    <label className="input-group" htmlFor="extraHours">
                        <span className="label">Extra Hours</span>
                        <input type='number' min="0" id="extraHours" name="extraHours" className='form-control textalignright' value={props.walkWayItem.extraHours} onChange={(e) => handleChangeNumber(e)} disabled={!props.canEdit} />
                    </label>

                    <label className="input-group" htmlFor="quoteNote">
                        <span className="label">Quote Note</span>
                        <input className="input" type="text" maxLength={20} id="quoteNote" name="quoteNote" value={props.walkWayItem.quoteNote} onChange={(e) => handleChange(e)}></input>
                    </label>
                    <p className="text--small">* Note will appear under Item name when printing the Quote</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="popup-button--yes" onClick={save}>Save</button>
                </Modal.Footer>
            </Modal>
        </div>
    );

    let contents = props.showModal
        ? renderDetails
        : <div></div>;

    return (
        <div>
            {contents}
        </div>
    )
}

export default JobQuoteWalkWayModal;